import { t, useLanguage, getLocale } from "@/i18n/LanguageContext";import { useEffect, useState } from "react";
import { MessagesSquare, ChevronDown, ChevronUp } from "lucide-react";
import { api } from "@/lib/api";

export default function ChatsTab({ onAuthError }) {useLanguage();
  const [sessions, setSessions] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    api.get("/admin/chats").
    then(({ data }) => setSessions(data)).
    catch((e) => {
      if (e.response?.status === 401) onAuthError();else
      setSessions([]);
    });
  }, [onAuthError]);

  if (sessions === null) {
    return <p className="py-10 text-center text-sm text-slate-500">{t("Caricamento conversazioni…")}</p>;
  }

  if (sessions.length === 0) {
    return (
      <div className="flex flex-col items-center rounded-2xl border border-dashed border-slate-300 bg-white py-16" data-testid="chats-empty">
        <MessagesSquare className="h-10 w-10 text-slate-300" />
        <p className="mt-4 text-sm text-slate-500">{t("Nessuna conversazione con il chatbot per ora.")}</p>
      </div>);

  }

  return (
    <div className="space-y-4" data-testid="chats-list">
      {t(sessions.map((s) => {
        const open = openId === s.session_id;
        return (
          <div key={s.session_id} data-testid={`chat-session-${s.session_id}`} className="rounded-2xl border border-slate-200 bg-white">
            <button
              data-testid={`chat-session-toggle-${s.session_id}`}
              onClick={() => setOpenId(open ? null : s.session_id)}
              className="flex w-full items-center justify-between gap-3 p-5 text-left">
              
              <div>
                <p className="font-display text-sm font-bold text-brand-navydeep">{t("Conversazione ")}
                  {t(s.session_id.slice(0, 8))}
                </p>
                <p className="mt-0.5 text-xs text-slate-500">
                  {t(s.messages.length)}{t(" messaggi · ultimo: ")}{t(new Date(s.last_at).toLocaleString(getLocale()))}
                </p>
              </div>
              {t(open ? <ChevronUp className="h-5 w-5 text-slate-400" /> : <ChevronDown className="h-5 w-5 text-slate-400" />)}
            </button>
            {t(open &&
            <div className="space-y-2 border-t border-slate-100 p-5">
                {t(s.messages.map((m, i) =>
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                    <div className={`max-w-[80%] whitespace-pre-wrap rounded-2xl px-4 py-2.5 text-sm ${
                m.role === "user" ? "bg-brand-navy text-white" : "bg-slate-100 text-slate-700"}`
                }>
                      {t(m.content)}
                    </div>
                  </div>
              ))}
              </div>)
            }
          </div>);

      }))}
    </div>);

}
